import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import { Kbd } from '@/components/ui/kbd';

interface CloseButtonProps {
  onClose: () => void;
}

export const CloseButton = ({ onClose }: CloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <InfoTooltip
      side="left"
      content={
        <span className="flex items-center gap-1">
          {t('common.close')}
          <Kbd>Esc</Kbd>
        </span>
      }
    >
      <Button
        variant="ghost-neutral"
        size="icon-sm"
        aria-label={t('modals.close')}
        onClick={onClose}
        className="absolute top-3 right-3"
      >
        <XIcon size={18} />
      </Button>
    </InfoTooltip>
  );
};
